import React from 'react';
import get from 'lodash/get';

import Icon from '../../../Icon/Icon';
import TableCell from '../../../Table/TableCell/TableCell';
import FormattedNumber from '../../../FormattedNumber/FormattedNumber';
import FormattedDate from '../../../FormattedDate/FormattedDate';
import Currency from '../../../Currency/Currency';
import Shimmer from '../../../Shimmer/Shimmer';

const getCustomCellByType = (column, current) => {
  const { cell } = column;

  if (cell && cell.type) {
    if (cell.type === 'number') {
      return (
        <TableCell key={column.key} freeze={column.freeze} {...cell}>
          <FormattedNumber value={current} />
        </TableCell>
      );
    }
    if (cell.type === 'date') {
      return (
        <TableCell key={column.key} freeze={column.freeze} {...cell}>
          <FormattedDate value={current} />
        </TableCell>
      );
    }
    if (cell.type === 'money') {
      return (
        <TableCell key={column.key} freeze={column.freeze} {...cell}>
          <Currency value={current} />
        </TableCell>
      );
    }
  }

  return null;
};

const getTableCell = (column, item, shimmer) => {
  const { cell } = column;
  const current = get(item, column.key);

  if (shimmer && shimmer.loading) {
    return (
      <TableCell key={column.key} freeze={column.freeze} {...cell}>
        <Shimmer.Rectangle height="20px" />
      </TableCell>
    );
  }

  if (current === null || current === undefined) {
    if (cell && cell.customEmpty) {
      const CustomEmpty = cell.customEmpty;
      return (
        <TableCell key={column.key} freeze={column.freeze} {...cell}>
          <CustomEmpty />
        </TableCell>
      );
    }
    return (
      <TableCell key={column.key} freeze={column.freeze} {...cell}>
        <Icon type="minus" />
      </TableCell>
    );
  }

  const cellComponent = getCustomCellByType(column, current);
  if (cellComponent) {
    return cellComponent;
  }

  if (cell && cell.component) {
    const CustomComponent = cell.component;
    return (
      <TableCell key={column.key} freeze={column.freeze} {...cell}>
        <CustomComponent {...item} />
      </TableCell>
    );
  }

  return (
    <TableCell key={column.key} freeze={column.freeze} {...cell}>
      {current}
    </TableCell>
  );
};

export default getTableCell;
